import { customizeValidator } from '@rjsf/validator-ajv8';

/**
 * Custom AJV8 validator that handles null values for string fields.
 *
 * RJSF v6 with AJV8 is strict about types - when schema says `type: "string"`,
 * it won't accept `null` values. This validator uses AJV's `coerceTypes` option
 * to automatically convert `null` to empty strings for string fields.
 *
 * This is particularly useful when the backend returns `null` for optional
 * string fields that haven't been set.
 */
export const customValidator = customizeValidator({
  ajvOptionsOverrides: {
    // Coerce null to empty string for string fields, etc.
    coerceTypes: true,
    // Allow additional properties that aren't in schema (common with dynamic backends)
    strict: false,
  },
});
